export const environment = {
  production: true,
  api: 'https://cms.placeme.io',
  ga: 'UA-129361664-1',
  livechatId: 25789576,
  googleMapApiKey: 'AIzaSyDhx89QdPmjwhu-tNV58c4L2k-moT9apEQ',
};
